import { render } from "./MicrophoneCheck.vue?vue&type=template&id=2cbeb230&scoped=true"
import script from "./MicrophoneCheck.vue?vue&type=script&lang=js"
export * from "./MicrophoneCheck.vue?vue&type=script&lang=js"

import "./MicrophoneCheck.vue?vue&type=style&index=0&id=2cbeb230&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2cbeb230"

export default script